import NZCDefaultLogo from '../components/assets/icons/default/nzc/search-icon.svg';
import AFLDefaultLogo from '../components/assets/icons/default/afl/football-icon.svg';
import NADefaultLogo from '../components/assets/icons/default/na/netball-icon.svg';
import NZCMapMarkerIcon from '../components/assets/icons/location-marker.svg';
import AFLMapMarkerIcon from '../components/assets/icons/map-pin-v2-fat.png';
import NAMapMarkerIcon from '../components/assets/icons/map-pin-na.png';
import {IConfig, IAppVersionForTenants, ITenantAppVersion, ITenantAppVersionConfig, IgnoredInclusionsTypes} from './ConfigTypes'
import settingsIcon from "../components/assets/icons/settings-icon.svg";
import settingsIcon_na from "../components/assets/icons/settings-icon-na.svg";
import ArrowLeftBlue from "../components/assets/icons/arrow-left-blue.svg";
import ArrowLeftWithBg from "../components/assets/icons/left-arrow-w-bg.svg";
import ArrowLeftBlack from '../components/assets/icons/arrow-left.svg';
import CancelIconAFL from "../components/assets/icons/cancel-icon-blue.svg"
import CancelIconNA from "../components/assets/icons/cancel-icon-na.svg"
import ChevronDownAFL from "../components/assets/icons/chevron-down-blue.svg"
import ChevronDownNA from "../components/assets/icons/chevron-down-na.svg"

export const Config: IConfig = {
  tenantList: {
    nzcTenant: 'nzc',
    aflTenant: 'afl',
    naTenant: 'na',
  },

  baseUrl: process.env.REACT_APP_CLUB_FINDER_API_ENDPOINT,
  apiEndpoints: {
    v1: {
      findResults: '/v1/finderresults', //params: ?lat=-36.8509&long=174.7645 query=fitzroy
      clubDetails: '/v1/orgdetails', //params: ?orgId=d5daef02-2614-4cd6-ac51-87a5a3f4968e
      configuration: '/v1/configuration', //params: ?finderId=abcd123
    },

    googleMapApi: {
      autoComplete: process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local' ?
        `${process.env.REACT_APP_WIREMOCK_ENDPOINT}/maps/api/place/autocomplete/json` :
        'https://maps.googleapis.com/maps/api/place/autocomplete/json', //params: ?input=hamil&components=country:nz&language=en&types=(regions)&key=<api key>
      details: process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local' ?
        `${process.env.REACT_APP_WIREMOCK_ENDPOINT}/maps/api/place/details/json` :
        'https://maps.googleapis.com/maps/api/place/details/json', // params ?place_id=ChIJITamh3QibW0RA5miQ2HvAAU&key=<api key>&fields=geometry/location
    }

  },
  map: {
    defaultCenter: {
      nzc: {
        lat: -40.9006,
        lng: 174.8860,
      },
      afl: {
        lat: -23.6038555,
        lng: 127.948899
      },
      na: {
        lat: -23.6038555,
        lng: 127.948899
      }
    },
    defaultZoom: {
      nzc: 6,
      afl: 6,
      na: 6,
    },
    controlledAreaZoom: {
      nzc: 6,
      afl: 5,
      na: 5,
    },
    singleResultZoom: 14,
    clusterZoom: {
      nzc: 12,
      afl: 12,
      na: 12
    },
    minDragAndSearchZoom: 10,
    maxZoom: 18,
    mapMarkerIcons: {
      nzc: NZCMapMarkerIcon,
      afl: AFLMapMarkerIcon,
      na: NAMapMarkerIcon,
    },
  },
  search: {
    minSearchLength: 3,
    noSearchPlaceholder: 'Looks like you haven’t searched for anything yet',
    noResultPlaceholder: 'No clubs found for selected location and filters',
    defaultLogos: {
      'nzc': NZCDefaultLogo,
      'afl': AFLDefaultLogo,
      'na': NADefaultLogo,
    }
  },
  breakpoints: {
    extraSmall: {width: 320, class: 'clubFinder-extraSmall'},
    small: {width: 480, class: 'clubFinder-small'},
    medium: {width: 720, class: 'clubFinder-medium'},
    large: {width: 920, class: 'clubFinder-large'},
    extraLarge: {width: 1440, class: 'clubFinder-extraLarge'},
  },
  defaultGenderOption: {type: 'anyone', name: 'Anyone'},
  defaultFormatOption: {name: 'All Formats', playHqFormats: ['All Format']},
  locationInputPlaceholder: {
    nzc: {
      desktop_text: 'Where do you want to play?',
      mobile_text: 'Where do you want to play?'
    },
    afl: {
      desktop_text: 'Find a suburb or club',
      mobile_text: 'Where do you want to play?'
    },
    na: {
      desktop_text: 'Find a suburb or club',
      mobile_text: 'Where do you want to play?'
    },

  },
  femaleInclusionPlayHQValue: "FEMALE_ONLY_PARTICIPANTS",
  aflFilterSearchParams: {
    genders: 'genders',
    formats: 'formats',
    inclusions: 'inclusions',
    days: 'days',
    orgId: 'orgId',
  },
  filterSearchParams: {
    afl: {
      genders: 'genders',
      formats: 'formats',
      inclusions: 'inclusions',
      days: 'days',
      orgId: 'orgId',
    },
    na: {
      genders: 'genders',
      formats: 'formats',
      inclusions: 'inclusions',
      days: 'days',
      orgId: 'orgId',
    }
  }
}
export const AppVersionForTenants: IAppVersionForTenants = {
  v1: {
    name: 'widget-version-one',
    tenants: [Config.tenantList.nzcTenant]
  },
  v2: {
    name: 'widget-version-two',
    tenants: [Config.tenantList.aflTenant, Config.tenantList.naTenant]
  },
}

export const TenantAppVersion: ITenantAppVersion = {
  nzc: 'v1',
  afl: 'v2',
  na: 'v2'
}

export const TenantAppVersionConfig: ITenantAppVersionConfig = {
  nzc: {
    version: 'v1',
    fonts: {
      fontPrimary: "Roboto, sans-serif",
      fontSecondary: "Inter, sans-serif"
    },
    colours:{},
    icons: {},
    postCodeSearchLength: 3,
  },
  afl: {
    version: 'v2',
    fonts: {
      fontPrimary: "Inter, sans-serif",
      fontSecondary: "Oswald, sans-serif"
    },
    colours: {
      brandPrimary: '#2f52e0',
    },
    icons: {
      settings: settingsIcon,
      leftArrow: ArrowLeftBlue,
      chevronDown: ChevronDownAFL,
      cancel: CancelIconAFL,
      singleResultBackButton: ArrowLeftBlack,
    },
    filterWidth: {
      small: '100%',
      medium: '50%',
      large: '35%'
    },
    postCodeSearchLength: 4,
  },
  na: {
    version: 'v2',
    fonts: {
      fontPrimary: "Gotham, sans-serif",
      fontSecondary: "Gotham, sans-serif"
    },
    colours: {
      brandPrimary: '#e98300',
    },
    icons: {
      settings: settingsIcon_na,
      leftArrow: ArrowLeftWithBg,
      chevronDown: ChevronDownNA,
      cancel: CancelIconNA,
      singleResultBackButton: ArrowLeftWithBg,
    },
    filterWidth: {
      small: '100%',
      medium: '50%',
      large: '43.51%'
    },
    postCodeSearchLength: 4,
  },
}

export const ignoredInclusions: IgnoredInclusionsTypes = {
  [Config.tenantList.aflTenant]: [],
  [Config.tenantList.nzcTenant]: [],
  [Config.tenantList.naTenant]: [Config.femaleInclusionPlayHQValue]
}

export const PLAYER_FEE_EXCLUDED_STATES: string[] = ['WA', 'SA'];
